import React from "react";
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

const BaseRefresh = ({ className, ...props }) =>
  <Tooltip title="Refresh">
    <Button
      { ...props }
      aria-label="Refresh"
      title="Refresh"
      className={ ["refresh-button", "toolbar-icon-button", className].filter(Boolean).join(" ") }
    >
      <ReloadOutlined className="refresh-button-icon" />
    </Button>
  </Tooltip>

export default BaseRefresh;
